import React from 'react';
import '../pageWelcome.css';
import { Typography } from 'antd';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';

const { Title } = Typography;

const PageWelcomeSelfcare = ({ selectedEvaluation, pageNumber, individualResult }) => {
    const gender = individualResult?.empl_gender;
    const greeting = gender === 'M' ? 'Bienvenido' : gender === 'F' ? 'Bienvenida' : 'Hola';
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                        {greeting}
                    </Title>

                    <div className="welcome-page-text">
                        Este informe fue creado pensando en ti y en algo que es verdaderamente
                        importante: tu bienestar y tu seguridad.
                        <br />
                        <br />
                        Cada día realizas un trabajo valioso que exige atención, esfuerzo físico y equilibrio
                        emocional. Sabemos que, en medio de la rutina, el cansancio, la presión o las
                        preocupaciones personales pueden influir en cómo nos sentimos y en cómo
                        actuamos. Por eso, este informe no busca señalar errores ni juzgarte, sino
                        ayudarte a reconocer las condiciones que pueden aumentar o disminuir tu
                        seguridad en el trabajo.
                        <br />
                        <br />
                        Aquí encontrarás información clara sobre tus fortalezas y sobre aquellas áreas
                        que pueden fortalecerse. Los resultados muestran cómo se combinan distintos
                        factores —como el bienestar físico, el manejo emocional y la atención— y cómo
                        esas combinaciones pueden influir en la probabilidad de cometer errores o
                        enfrentar situaciones de riesgo.
                        <br />
                        <br />
                        Este no es un diagnóstico ni una evaluación disciplinaria. Es una herramienta de
                        autocuidado, diseñada para que puedas:
                        <br />
                        <ul>
                            <li>Tomar mayor conciencia de tu estado actual,</li>
                            <li>Identificar momentos en los que necesitas cuidarte más,</li>
                            <li>Recibir apoyo oportuno cuando lo requieras.</li>
                        </ul>
                        Creemos firmemente que la seguridad comienza por el cuidado de las personas.
                        Cuando te cuidas, cuidas a tus compañeros, a tu familia y a todo el equipo.
                        <br />
                        <br />
                        Te invitamos a leer este informe con apertura y honestidad. Cada pequeño cambio
                        cuenta y cada acción de autocuidado puede marcar la diferencia para regresar
                        sano y seguro a casa todos los días.
                        <br />
                        <br />
                        Gracias por tu compromiso, tu trabajo y por ser parte activa de una cultura donde
                        la vida y el bienestar son lo primero.
                        <br />
                        <br />
                        Con aprecio,
                        <br />
                        <div className="welcome-page-signature-name">Equipo Talentha</div>
                        <div className="welcome-page-signature-jobtitle">Analítica para el cuidado de las personas</div>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageWelcomeSelfcare;
